import React from 'react';
import { GeneralContractorFormData, FormErrors, postalCodeRegex } from './types';
import { POSTAL_CODE_PROVINCE_MAP } from '../AddressStep';

export const validateStep1 = (
  formData: GeneralContractorFormData,
  setErrors: React.Dispatch<React.SetStateAction<FormErrors>>
): boolean => {
  let isValid = true;
  const newErrors: FormErrors = {
    name: '',
    address: '',
    city: '',
    province: '',
    postalCode: '',
  };

  // Name validation
  if (!formData.name.trim()) {
    newErrors.name = 'General contractor name is required';
    isValid = false;
  } else if (formData.name.length < 2) {
    newErrors.name = 'Name must be at least 2 characters';
    isValid = false;
  } else if (formData.name.length > 100) {
    newErrors.name = 'Name must be less than 100 characters';
    isValid = false;
  }

  setErrors(newErrors);
  return isValid;
};

export const validateStep2 = (
  formData: GeneralContractorFormData,
  setErrors: React.Dispatch<React.SetStateAction<FormErrors>>,
  provinces: { id: string; name: string }[] = []
): boolean => {
  let isValid = true;
  const newErrors: FormErrors = {
    name: '',
    address: '',
    city: '',
    province: '',
    postalCode: '',
  };

  if (formData.address && formData.address.length > 200) {
    newErrors.address = 'Address must be less than 200 characters';
    isValid = false;
  }

  if (formData.city && formData.city.length > 100) {
    newErrors.city = 'City must be less than 100 characters';
    isValid = false;
  }

  if (formData.province && !formData.province.trim()) {
    newErrors.province = 'Please select a valid province';
    isValid = false;
  }

  if (formData.postalCode && formData.postalCode.trim()) {
    if (!postalCodeRegex.test(formData.postalCode)) {
      newErrors.postalCode = 'Please enter a valid Canadian postal code (e.g., A1A 1A1)';
      isValid = false;
    } else if (formData.province) {
      const prefix = formData.postalCode.trim()[0].toUpperCase();
      const validProvinces = POSTAL_CODE_PROVINCE_MAP[prefix];
      const selectedProvince = provinces.find(p => p.id === formData.province);
      if (validProvinces && selectedProvince && !validProvinces.includes(selectedProvince.name)) {
        newErrors.postalCode = `This postal code does not belong to ${selectedProvince.name}`;
        isValid = false;
      }
    }
  }

  setErrors(newErrors);
  return isValid;
};